import { get, post, patch, remove, postHubSpotRegister } from '@/helpers/http'
import utility from '@/helpers/utility'

const state = {
  id: undefined,
  data: undefined,
  token: undefined,
  tokenExpires: undefined,
  initials: undefined,
  notifications: undefined,
  settings: undefined,
  subscriptionStatus: 'guest',
  refreshing: false
}

const getters = {
  isAuthenticated (state) {
    let token = localStorage.getItem('token')
    let tokenExpires = localStorage.getItem('tokenExpires')

    if (state.id) {
      return true
    } else if (token && tokenExpires > (Math.floor(Date.now() / 1000))) {
      return true
    }

    return false
  },

  data (state) { // temp...
    return state.data
  },

  getData (state) {
    return state.data
  },

  getName (state) {
    if (state.data && state.data.first_name && state.data.last_name) {
      return state.data.first_name + ' ' + state.data.last_name
    } else {
      return false
    }
  },

  getFirstName (state) {
    if (state.data && state.data.first_name) {
      return state.data.first_name
    }

    return ''
  },

  getInitials (state) {
    let initials = '?'

    if (state.data && state.data.first_name && state.data.last_name) {
      initials = state.data.first_name.charAt(0) + state.data.last_name.charAt(0)
    }

    return initials.toUpperCase()
  },

  getNotifications (state) {
    return state.notifications
  },

  getSettings (state) {
    return state.settings
  },

  getSubscriptionStatus (state) {
    return state.subscriptionStatus
  }
}

const actions = {
  async register ({ state }, formData) {
    let response = await post('users', formData)

    if (response.status === 201) {
      if (formData.step && formData.step === 'a') {
        utility.sendGoogleAnalyticsEvent('auth_pre_register', false, false, state.subscriptionStatus)
      } /*else if (formData.step && formData.step === 'b') {
        utility.sendGoogleAnalyticsEvent('PreRegisterDetails', 'Auth', new Date().toLocaleString('fi'), false, this.isAuthenticated, this.subscriptionStatus)
      }*/ else if (formData.step && formData.step === 'c') {
        utility.sendGoogleAnalyticsEvent('auth_register', false, false, state.subscriptionStatus)
      }
    }

    return response.data
  },

  async resendVerification ({}, formData) {
    let response = await post('users/resend', formData)
    return response.data
  },

  async hubspot ({ dispatch }, payload) {
    return await postHubSpotRegister(payload)
  },

  async login ({ dispatch, state }, credentials) {
    let response = await post('users/login', credentials)
    dispatch('setLoginState', response.data.data)

    if (response.status === 200) {
      let status = response.data.data.attributes.subscription_status
      dispatch('fetchSettings')
      dispatch('fetchNotifications')
      dispatch('setSubscriptionStatus', status)
      utility.sendGoogleAnalyticsEvent('auth_login', false, false, state.subscriptionStatus)
    }

    return response.data
  },

  async logout ({ dispatch, state }) {
    await post('users/logout')
    utility.sendGoogleAnalyticsEvent('auth_logout', false, false, state.subscriptionStatus)
    dispatch('setSubscriptionStatus', 'guest')
    dispatch('setLoginState', false)
  },

  async refresh ({ state, dispatch, commit }) {
    let tokenCheck = localStorage.getItem('token')
    let expiresCheck = localStorage.getItem('tokenExpires')
    let lastRefresh = localStorage.getItem('lastRefresh')

    if (tokenCheck && expiresCheck && ((parseInt(lastRefresh) + 36000) <= Math.floor(Date.now() / 1000)) && (!state.token || (Math.floor(Date.now() / 1000) + 36000) >= expiresCheck) && state.refreshing === false) {
      commit('SET_REFRESHING', true)

      try {
        let response = await post('users/refresh', false, 'refreshing')
        dispatch('refreshState', response.data)
        commit('SET_REFRESHING', false)
      } catch {
        commit('SET_REFRESHING', false)
      }
    }

    return true
  },

  async edit ({ dispatch }, formData) {
    let response = await post('users/edit', formData)
    dispatch('setState', response.data)
    return response.data
  },

  async forgotPassword ({ dispatch }, formData) {
    let response = await post('users/forgot', formData)
    return response.data
  },

  async addNotification ({ dispatch }, formData) {
    let response = await post('notifications', formData)
    return response.data
  },

  async editNotification ({}, formData) {
    let response = await patch('notifications/' + formData.id, formData)
    return response.data
  },

  async deleteNotification ({}, id) {
    let response = await remove('notifications/' + id)
    return response.data
  },

  async addSettings ({}, formData) {
    let response = await post('settings', formData)
    return response.data
  },

  async updateSettings ({}, formData) {
    let response = await patch('settings/' + formData.id, formData.data)
    return response.data
  },

  async fetchSettings ({ state, commit, dispatch }) {
    let response = await get('users/' + state.id + '/settings')

    if (response && response.data) {
      let results = {}
      let resultIds = []
      let settings = []

      response.data.data.forEach(result => {
        if (result.type === 'settings') {
          let resultId = 'SETTING_' + result.attributes.name

          results[resultId] = result
          resultIds.push(resultId)
          settings.push({
            'name': 'user.' + result.attributes.name,
            'value': result.attributes.value
          })
        }
      })

      let normalizedResults = {
        'byId': results,
        'allIds': resultIds
      }

      commit('SET_SETTINGS', normalizedResults)
      dispatch('app/setSettings', settings, { root:true })
      return true
    }

    commit('SET_STATUS', 'error')
    return false
  },

  setSettings ({ commit }, value) {
    commit('SET_SETTINGS', value)
  },

  async getLicenses ({}) {
    let response = await post('user/licenses')
    return response.data
  },

  async fetchNotifications ({ state, commit }) {
    let response = await get('users/' + state.id + '/notifications')

    if (response && response.data) {
      let results = {}
      let resultIds = []

      response.data.data.forEach(result => {
        if (result.type === 'notifications') {
          let resultId = 'NOTIFICATION_' + result.id

          results[resultId] = result
          resultIds.push(resultId)
        }
      })

      let normalizedResults = {
        'byId': results,
        'allIds': resultIds
      }

      commit('SET_NOTIFICATIONS', normalizedResults)
      return true
    }

    commit('SET_STATUS', 'error')
    return false
  },

  setNotifications ({ commit }, value) {
    commit('SET_NOTIFICATIONS', value)
  },

  setSubscriptionStatus ({ commit }, value) {
    commit('SET_SUBSCRIPTION_STATUS', value)
  },

  setState ({ commit }, newState) {
    commit('setId', newState.id ? newState.id : undefined)
    commit('setData', newState ? newState.attributes : undefined)
  },

  setLoginState ({ commit }, newState) {
    commit('setId', newState ? newState.id : undefined)
    commit('setData', newState ? newState.attributes : undefined)
    commit('setToken', newState && newState.attributes && newState.attributes.auth ? newState.attributes.auth.access_token : undefined)
    commit('setTokenExpires', newState && newState.attributes && newState.attributes.auth ? (Math.floor(Date.now() / 1000) + newState.attributes.auth.expires_in) : undefined)

    newState && newState.attributes && newState.attributes.auth ? localStorage.setItem('token', newState.attributes.auth.access_token) : localStorage.removeItem('token')
    newState && newState.attributes && newState.attributes.auth ? localStorage.setItem('tokenExpires', (Math.floor(Date.now() / 1000) + newState.attributes.auth.expires_in)) : localStorage.removeItem('tokenExpires')
  },

  refreshState ({ commit }, newState) {
    if (newState.auth) {
      commit('setToken', newState.auth.access_token)
      commit('setTokenExpires', (Math.floor(Date.now() / 1000) + newState.auth.expires_in))
      localStorage.setItem('lastRefresh', Math.floor(Date.now() / 1000))
    } else {
      commit('setId', undefined)
      commit('setData', undefined)
      commit('setToken', undefined)
      commit('setTokenExpires', undefined)
      localStorage.removeItem('lastRefresh')
    }

    newState.auth ? localStorage.setItem('token', newState.auth.access_token) : localStorage.removeItem('token')
    newState.auth ? localStorage.setItem('tokenExpires', (Math.floor(Date.now() / 1000) + newState.auth.expires_in)) : localStorage.removeItem('tokenExpires')
  },
  /* eslint-disable */
  async sendPayment ({}, formData) {
    let response = await post('payments', formData)
    return response.data
  },

  async setupCard ({}) {
    let response = await post('intents/card')
    return response.data
  },

  async confirmPayment ({}, paymentId) {
    let response = await get('payments/' + paymentId)

    if (response) {
      return response.data
    } else {
      return false
    }
  }
  /* eslint-enable */
}

const mutations = {
  setId (state, value) {
    state.id = value
  },
  setData (state, value) {
    state.data = value
  },
  setToken (state, value) {
    state.token = value
  },
  setTokenExpires (state, value) {
    state.tokenExpires = value
  },
  setSettings (state, value) {
    state.settings = value
  },
  setFilters (state, value) {
    state.filters = value
  },
  setStats (state, value) {
    state.stats = value
  },
  setLatest (state, value) {
    state.latest = value
  },
  setCompany (state, value) {
    state.company = value
  },
  SET_REFRESHING (state, value) {
    state.refreshing = value
  },
  SET_SUBSCRIPTION_STATUS (state, value) {
    state.subscriptionStatus = value
  },
  SET_NOTIFICATIONS (state, value) {
    state.notifications = value
  },
  SET_SETTINGS (state, value) {
    state.settings = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
